import { Button } from "@mui/material";
import { MeetingNotesDrawerContent, useDrawer } from "src/components";
import { MeetingType } from "src/constants";

const MeetingNotesButton = (props: { meetingGuid: string; meetingType: MeetingType }) => {
  const { showDrawer } = useDrawer();

  function handleMeetingNotesClicked() {
    showDrawer({
      content: <MeetingNotesDrawerContent meetingGuid={props.meetingGuid} />,
    });
  }

  return (
    <Button variant="tertiary" onClick={handleMeetingNotesClicked}>
      Meeting Notes
    </Button>
  );
};

export { MeetingNotesButton };
